var AC_Campaign = {
  version: 1,
  url_base: "",
  whitelist: ["create", "delete_list", "delete", "list", "paginator", "report_bounce_list", "report_bounce_totals", "report_forward_list", "report_forward_totals", "report_link_list", "report_link_totals", "report_open_list", "report_open_totals", "report_totals", "report_unopen_list", "report_unsubscription_list", "report_unsubscription_totals", "send", "status"]
};
module.exports = AC_Campaign;